import { useMemo, useState } from 'react';
import Select from 'react-select';
import axios from '../_actions/axiosInstance';
import {
  DropdownIndicator,
  SelectStyled,
  themeOverride
} from '../components/ReactSelectWrapper';
import useDashboardStore from '../pages/dashboard/store/DashboardStore';
import useAxios from '../hooks/useAxios';
import config from '../_config/config';
import { NewFullPageSpinner } from '../helpers/Spiners';

const ClientSelect = () => {
  const [
    { selectedClient, clientView },
    { setClient, toggleView, resolveConfig, clearConfig }
  ] = useDashboardStore();
  const [loadingConfig, setLoadingConfig] = useState(false);
  const { response, loading } = useAxios(`${config.api.api_url}${config.api.dashboard.clients}`);

  const changeClient = async val => {
    if (!val) {
      setClient(null);
      resolveConfig();
      return;
    }
    setLoadingConfig(true);
    try {
      const res = await axios.get(
        `${config.api.api_url}${config.api.dashboard.client_config(val.id)}`
      );
      resolveConfig(res.data.data);
    } catch (e) {
      clearConfig();
    }
    if (!clientView && !val.assigned) {
      toggleView(true);
    }
    setClient(val);
    setLoadingConfig(false);
  };

  const singleClient = useMemo(() => {
    if (!response?.data?.length) return false;
    if (response.data.length === 1) {
      changeClient(response.data[0]);
      return true;
    }
    return false;
  }, [response]);

  const clientsOpts = useMemo(() => {
    if (!response?.data?.length) return [];
    if (!clientView) return response.data.filter(x => x.assigned);
    return response.data;
  }, [response, clientView]);

  if (!window.location.href.includes('dashboard')) {
    return <></>;
  }
  return (
    <div className={`client-search ${singleClient && 'd-none'}`}>
      {loadingConfig && <NewFullPageSpinner />}
      <Select
        theme={themeOverride}
        styles={SelectStyled}
        options={clientsOpts}
        value={selectedClient}
        isClearable
        isLoading={loading}
        placeholder="Select client"
        getOptionValue={option => option.id}
        getOptionLabel={option => option.label}
        onChange={val => changeClient(val)}
        components={{ DropdownIndicator }}
        menuPortalTarget={document.getElementById('portal-select-hack')}
      />
    </div>
  );
};

export default ClientSelect;
